import React from 'react';
import Pnavbar from '../components/JSX/Pnavbar';
import Slider7 from '../components/JSX/Slider7';
import Dev from '../components/JSX/Development';
import Footerp2 from '../components/JSX/Footerp2';

const Corporate = () => (
  <>
    <Pnavbar />
    <Slider7 />
    <Dev/>
    <Footerp2/>
  </>
);

export default Corporate